<template>
    <div class="sequence-visual-list-model" style="text-align: center">
        <UiTooltipFunction ref="tooltip" :content="$t('Placeholder.ClickViewSequence')" style="display: block">
            <div class="visual-list-model-canvas" ref="canvas"></div>
        </UiTooltipFunction>
        <div class="visual-list-model-more" @click="more()" v-if="data.length > 5">
            <span>{{ isMore ? $t("Receive") : $t("ViewAll") }}</span>
            <UiIcon name="arrow" class="module5-more-icon" :style="{ transform: isMore ? 'rotate(180deg)' : '' }" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { UiIcon, UiTooltipFunction } from "various-ui";
import { useComposable } from "./src/composable";
import { VisualListSequenceModelEmits } from "./index";

//* 组件声明
const emits = defineEmits(VisualListSequenceModelEmits);

//* 组合函数
const { refs, methods, variable } = useComposable(emits);
const { tooltip, canvas, isMore } = refs;
const { data } = variable;
const { more, init } = methods;

//* 导出函数
defineExpose({ init });
</script>

<style lang="less" scoped>
.sequence-visual-list-model {
    .visual-list-model-canvas {
        overflow: auto hidden;
    }

    .visual-list-model-more {
        border-radius: 8px;
        line-height: 56px;
        user-select: none;
        transition: all 0.3s;
        margin-top: 10px;
        display: inline-block;
        padding: 0 32px;
        cursor: pointer;
    }

    .visual-list-model-more:hover {
        background-color: var(--uicolor-font-4-02);
    }
}
</style>
